/**
 * Random Bot Name Generator
 * Generates a random human-sounding name for the bot assistant
 */

const NAME_POOL = [
  'Sarah',
  'Alex',
  'Jordan',
  'Taylor',
  'Madison',
  'Riley',
  'Morgan',
  'Casey',
  'Jamie',
  'Drew',
  'Blake',
  'Quinn',
  'Avery',
  'Cameron',
]

/**
 * Generate a random bot name from the pool
 * Uses a seed to ensure consistency within a conversation
 */
export function generateBotName(seed?: string): string {
  if (seed) {
    // Use seed to deterministically select a name
    let hash = 0
    for (let i = 0; i < seed.length; i++) {
      hash = (hash << 5) - hash + seed.charCodeAt(i)
      hash = hash & hash // Convert to 32-bit integer
    }
    const index = Math.abs(hash) % NAME_POOL.length
    const name = NAME_POOL[index]
    if (!name) {
      throw new Error('Failed to generate bot name from seed')
    }
    return name
  }

  // Random selection
  const index = Math.floor(Math.random() * NAME_POOL.length)
  const name = NAME_POOL[index]
  if (!name) {
    throw new Error('Failed to generate random bot name')
  }
  return name
}

/**
 * Get all available bot names
 */
export function getAllBotNames(): string[] {
  return [...NAME_POOL]
}
